"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SurveyMultipleTextbox',
  props: {
    value: Array
  },
  methods: {
    handleAdd() {
      this.value.push({
        value: ''
      });
    },
    handleRemove(index) {
      this.value.splice(index, 1);
    },
    handleChange(item) {
      item.value = item.value.trim();
    }
  }
};